import { Component } from '@angular/core';
import { FormBuilder, Formio } from 'formiojs';
import { Router } from '@angular/router';
import * as moment from 'moment';

@Component({
  selector: 'app-east-coast-2',
  templateUrl: './east-coast-2.component.html',
})
export class EastCoast2Component {
//   Formio.builder(document.getElementById('builder'), {}).then(function(form){
//     form.webform.submission = {
//         data: prefilledDataObject
//     };
// });

formSpec: any;
formData: any;
router: Router;
constructor(router: Router) {
  this.router = router;
}

ngOnInit() {
  var state = 'NSW';
  var abc = moment('2020-02-15T00:00:00+11:00').add(12, 'months').toISOString(); // get the hard coded date from previous form
  var checkRefDate = moment().add(-3, 'months').toISOString();
  var checkState = function(state: string) {
    if (state === 'VIC' || state === 'TAS'){
      return true;
    }
    return false;
  }
  var stateVic = checkState('VIC');
    this.formSpec = {
        "title": "My Test Form",
        "components": [
          {
            "type": "radio",
            "label": "The relevant details regarding payment claims can be found in (relevant legislation): Was a payment claim served?",
            "input": true,
            "inline": true,
            "tableView": false,
            "key": "paymentClaimServed",
            "persistent": true,
              values: [
                {value: 'yes', label: 'Yes'},
                {value: 'no', label: 'No'}
              ],
              "validate": {
                "required": true
            }
          },
          {
            "type": "htmlelement",
            "input": false,
            "tableView": true,
            "content": "Your claim may be invalid under (relevant legislation)",
            "inputMask": "",
            "key": "claimUnderLegislationText",
            "prefix": "",
            "suffix": "",
            "multiple": false,
            "protected": false,
            "unique": false,
            "persistent": true,
            "conditional": {
              "json": {
                "===": [
                  {
                    "var": "data.paymentClaimServed"
                  },
                  "no"
                ],
              }
            }
          },
          {
            "type": "radio",
            "label": "State that the claim was made under (relevant legislation)?",
            "input": true,
            "inline": true,
            "tableView": false,
            "key": "claimUnderLegislation",
            "persistent": true,
              values: [
                {value: 'yes', label: 'Yes'},
                {value: 'no', label: 'No'}
              ],
              "validate": {
                "required": true
            }
          },
          {
            "type": "htmlelement",
            "input": false,
            "tableView": true,
            "content": "Your claim may be invalid under (relevant legislation)",
            "inputMask": "",
            "key": "claimUnderLegislationText1",
            "prefix": "",
            "suffix": "",
            "multiple": false,
            "protected": false,
            "unique": false,
            "persistent": true,
            "conditional": {
              "json": {
                "===": [
                  {
                    "var": "data.claimUnderLegislation"
                  },
                  "no"
                ],
              }
            }
          },
          {
            "type": "radio",
            "label": "Did the payment claim identify the relevant work or related goods and services?",
            "input": true,
            "inline": true,
            "tableView": false,
            "key": "paymentClaimIdentifyRelaventWork",
            "persistent": true,
              values: [
                {value: 'yes', label: 'Yes'},
                {value: 'no', label: 'No'}
              ],
              "validate": {
                "required": true
            }
          },
          {
            "type": "htmlelement",
            "input": false,
            "tableView": true,
            "content": "Your claim may be invalid under (relevant legislation)",
            "inputMask": "",
            "key": "claimUnderLegislationText3",
            "prefix": "",
            "suffix": "",
            "multiple": false,
            "protected": false,
            "unique": false,
            "persistent": true,
            "conditional": {
              "json": {
                "===": [
                  {
                    "var": "data.paymentClaimIdentifyRelaventWork"
                  },
                  "no"
                ],
              }
            }
          },
          {
            "label": "Currency",
            "mask": false,
            "spellcheck": true,
            "tableView": false,
            "currency": "AUD",
            "inputFormat": "plain",
            "key": "currency",
            "type": "currency",
            "input": true,
            "delimiter": true,
            "validate": {
                "required": true,
                "customPrivate": false
            }
          },
          {
              "label": "Date of Claim",
              "format": "yyyy-MM-dd",
              "tableView": false,
              "enableMinDateInput": false,
              "datePicker": {
                  "disableWeekends": false,
                  "disableWeekdays": false
              },
              "enableMaxDateInput": false,
              "enableTime": false,
              "timePicker": {
                  "showMeridian": false
              },
              "key": "dateOfClaim",
              "type": "datetime",
              "input": true,
              "widget": {
                  "type": "calendar",
                  "displayInTimezone": "viewer",
                  "locale": "en",
                  "useLocaleSettings": false,
                  "allowInput": true,
                  "mode": "single",
                  "enableTime": false,
                  "noCalendar": false,
                  "format": "yyyy-MM-dd",
                  "hourIncrement": 1,
                  "minuteIncrement": 1,
                  "time_24hr": true,
                  "minDate": null,
                  "disableWeekends": false,
                  "disableWeekdays": false,
                  "maxDate": null
              },
              "validate": {
                "required": true,
                "customPrivate": false
              }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "Your payment claim may be ineligible under s13 (4)(b) of the Act",
              "inputMask": "",
              "key": "claimUnderLegislationText3",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              "conditional": {
                "json": {
                  ">": [
                    {
                      "var": "data.dateOfClaim"
                    },
                    abc
                  ],
                }
              }
            },
            {
              "label": "Date served",
              "format": "yyyy-MM-dd",
              "tableView": false,
              "enableMinDateInput": false,
              "datePicker": {
                  "disableWeekends": false,
                  "disableWeekdays": false
              },
              "enableMaxDateInput": false,
              "enableTime": false,
              "timePicker": {
                  "showMeridian": false
              },
              "key": "dateServed",
              "type": "datetime",
              "input": true,
              "widget": {
                  "type": "calendar",
                  "displayInTimezone": "viewer",
                  "locale": "en",
                  "useLocaleSettings": false,
                  "allowInput": true,
                  "mode": "single",
                  "enableTime": false,
                  "noCalendar": false,
                  "format": "yyyy-MM-dd",
                  "hourIncrement": 1,
                  "minuteIncrement": 1,
                  "time_24hr": true,
                  "minDate": null,
                  "disableWeekends": false,
                  "disableWeekdays": false,
                  "maxDate": null
              },
              "validate": {
                "required": true,
                "customPrivate": false
              },

            },
            {
              "label": "Due date for payment",
              "format": "yyyy-MM-dd",
              "tableView": false,
              "enableMinDateInput": false,
              "datePicker": {
                  "disableWeekends": false,
                  "disableWeekdays": false
              },
              "enableMaxDateInput": false,
              "enableTime": false,
              "timePicker": {
                  "showMeridian": false
              },
              "key": "dueDatForPayment",
              "type": "datetime",
              "input": true,
              "widget": {
                  "type": "calendar",
                  "displayInTimezone": "viewer",
                  "locale": "en",
                  "useLocaleSettings": false,
                  "allowInput": true,
                  "mode": "single",
                  "enableTime": false,
                  "noCalendar": false,
                  "format": "yyyy-MM-dd",
                  "hourIncrement": 1,
                  "minuteIncrement": 1,
                  "time_24hr": true,
                  "minDate": null,
                  "disableWeekends": false,
                  "disableWeekdays": false,
                  "maxDate": null
              },
              "validate": {
                "required": true,
                "customPrivate": false
              }
            },
            {
              "label": "Reference date",
              "format": "yyyy-MM-dd",
              "tableView": false,
              "enableMinDateInput": false,
              "datePicker": {
                  "disableWeekends": false,
                  "disableWeekdays": false
              },
              "enableMaxDateInput": false,
              "enableTime": false,
              "timePicker": {
                  "showMeridian": false
              },
              "key": "referenceDate",
              "type": "datetime",
              "input": true,
              "widget": {
                  "type": "calendar",
                  "displayInTimezone": "viewer",
                  "locale": "en",
                  "useLocaleSettings": false,
                  "allowInput": true,
                  "mode": "single",
                  "enableTime": false,
                  "noCalendar": false,
                  "format": "yyyy-MM-dd",
                  "hourIncrement": 1,
                  "minuteIncrement": 1,
                  "time_24hr": true,
                  "minDate": null,
                  "disableWeekends": false,
                  "disableWeekdays": false,
                  "maxDate": null
              },
              "validate": {
                "required": stateVic,
                "customPrivate": false
              }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "Your payment claim may be ineligible under s14 (4)(b) of the Act",
              "inputMask": "",
              "key": "claimUnderLegislationText4",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              "conditional": {
                "json": {
                  "and": [
                    {"<": [{"var": "data.referenceDate"}, checkRefDate]},
                    {">": [{"var": "data.referenceDate"}, "0000-00-00T00:00:00+11:00"]},
                    {"===": [state, "NSW"]}

                  ]
                }
              }
            },
            {
              "type": "radio",
              "label": "The relevant details regarding payment schedules can be found in (relevant legislation) Was a payment Schedule provided?",
              "input": true,
              "inline": true,
              "tableView": false,
              "key": "relaventDetailsRegardingPaymentSchedule",
              "persistent": true,
                values: [
                  {value: 'yes', label: 'Yes'},
                  {value: 'no', label: 'No'}
                ],
                "validate": {
                  "required": true
                }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "Your payment claim may be ineligible under s14 (4)(b) of the Act",
              "inputMask": "",
              "key": "claimUnderLegislationText_relaventDetailsRegardingPaymentSchedule",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              "conditional": {
                "json": {
                  "===": [
                    {
                      "var": "relaventDetailsRegardingPaymentSchedule"
                    },
                    "no"
                  ]
                }
              }
            },



            {
              "type": "radio",
              "label": "Did the payment schedule Identify the relevant claim?",
              "input": true,
              "inline": true,
              "tableView": false,
              "key": "paymentScheduleIdentityRelaventClaim",
              "persistent": true,
                values: [
                  {value: 'yes', label: 'Yes'},
                  {value: 'no', label: 'No'}
                ],
                "validate": {
                  "required": true
                },
                "conditional": {
                  "json": {
                    "===": [
                      {
                        "var": "relaventDetailsRegardingPaymentSchedule"
                      },
                      "yes"
                    ],
                  }
                }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "Your claim may be invalid under (relevant legislation)",
              "inputMask": "",
              "key": "claimUnderLegislationText_paymentScheduleIdentityRelaventClaim",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              "conditional": {
                "json": {
                  "===": [
                    {
                      "var": "paymentScheduleIdentityRelaventClaim"
                    },
                    "no"
                  ],
                }
              }
            },
            {
              "type": "radio",
              "label": "Did the payment schedule Identify the relevant claim?",
              "input": true,
              "inline": true,
              "tableView": false,
              "key": "IdentifiesClaim",
              "persistent": true,
                values: [
                  {value: 'yes', label: 'Yes'},
                  {value: 'no', label: 'No'}
                ],
                "validate": {
                  "required": true
                },
                "conditional": {
                  "json": {
                    "===": [
                      {
                        "var": "relaventDetailsRegardingPaymentSchedule"
                      },
                      "yes"
                    ],
                  }
                }
            },
            {
              "label": "Scheduled amount (excl. GST)",
              "mask": false,
              "spellcheck": true,
              "tableView": false,
              "currency": "AUD",
              "inputFormat": "plain",
              "key": "scheduledAmount",
              "type": "currency",
              "input": true,
              "delimiter": true,
              "validate": {
                  "required": true,
                  "customPrivate": false
              },
              "conditional": {
                "json": {
                  "===": [
                    {
                      "var": "relaventDetailsRegardingPaymentSchedule"
                    },
                    "yes"
                  ],
                }
              }
            },
            {
              "label": "Excluded amount (excl.GST)",
              "mask": false,
              "spellcheck": true,
              "tableView": false,
              "currency": "AUD",
              "inputFormat": "plain",
              "key": "excludedAmount",
              "type": "currency",
              "input": true,
              "delimiter": true,
              "validate": {
                  "required": true,
                  "customPrivate": false
              },
              "conditional": {
                "json": {
                  "===": [
                    {
                      "var": "relaventDetailsRegardingPaymentSchedule"
                    },
                    "yes"
                  ],
                }
              }
            },
            {
              "type": "textfield",
              "input": true,
              "tableView": true,
              "inputType": "text",
              "inputMask": "",
              "label": "If the scheduled amount was less than claimed amount, did  reasons for withholding the difference?",
              "key": "reasonForWithholding",
              "placeholder": "Name",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "defaultValue": "",
              "protected": false,
              "unique": false,
              "persistent": true,
              "validate": {
                  "required": true,
                  "customPrivate": false
              },
              "conditional": {
                "json": {
                  "===": [
                    {
                      "var": "relaventDetailsRegardingPaymentSchedule"
                    },
                    "yes"
                  ],
                }
              }
            },
            {
              "label": "Schedule Date",
              "format": "yyyy-MM-dd",
              "tableView": false,
              "enableMinDateInput": false,
              "datePicker": {
                  "disableWeekends": false,
                  "disableWeekdays": false
              },
              "enableMaxDateInput": false,
              "enableTime": false,
              "timePicker": {
                  "showMeridian": false
              },
              conditional: {
                "json": {
                  "===": [
                    {
                      "var": "relaventDetailsRegardingPaymentSchedule"
                    },
                    "yes"
                  ]
                }
              },
              "key": "scheduleDate",
              "type": "datetime",
              "input": true,
              "widget": {
                  "type": "calendar",
                  "displayInTimezone": "viewer",
                  "locale": "en",
                  "useLocaleSettings": false,
                  "allowInput": true,
                  "mode": "single",
                  "enableTime": false,
                  "noCalendar": false,
                  "format": "yyyy-MM-dd",
                  "hourIncrement": 1,
                  "minuteIncrement": 1,
                  "time_24hr": true,
                  "minDate": null,
                  "disableWeekends": false,
                  "disableWeekdays": false,
                  "maxDate": null
              }
            },
            {
              "label": "Date received",
              "format": "yyyy-MM-dd",
              "tableView": false,
              "enableMinDateInput": false,
              "datePicker": {
                  "disableWeekends": false,
                  "disableWeekdays": false
              },
              "enableMaxDateInput": false,
              "enableTime": false,
              "timePicker": {
                  "showMeridian": false
              },
              conditional: {
                "json": {
                  "===": [
                    {
                      "var": "relaventDetailsRegardingPaymentSchedule"
                    },
                    "yes"
                  ]
                }
              },
              "key": "dateReceived",
              "type": "datetime",
              "input": true,
              "widget": {
                  "type": "calendar",
                  "displayInTimezone": "viewer",
                  "locale": "en",
                  "useLocaleSettings": false,
                  "allowInput": true,
                  "mode": "single",
                  "enableTime": false,
                  "noCalendar": false,
                  "format": "yyyy-MM-dd",
                  "hourIncrement": 1,
                  "minuteIncrement": 1,
                  "time_24hr": true,
                  "minDate": null,
                  "disableWeekends": false,
                  "disableWeekdays": false,
                  "maxDate": null
              }
            },
            {
              "label": "Due date for payment",
              "format": "yyyy-MM-dd",
              "tableView": false,
              "enableMinDateInput": false,
              "datePicker": {
                  "disableWeekends": false,
                  "disableWeekdays": false
              },
              "enableMaxDateInput": false,
              "enableTime": false,
              "timePicker": {
                  "showMeridian": false
              },
              conditional: {
                "json": {
                  "===": [
                    {
                      "var": "relaventDetailsRegardingPaymentSchedule"
                    },
                    "yes"
                  ]
                }
              },
              "key": "dueDateForPayment",
              "type": "datetime",
              "input": true,
              "widget": {
                  "type": "calendar",
                  "displayInTimezone": "viewer",
                  "locale": "en",
                  "useLocaleSettings": false,
                  "allowInput": true,
                  "mode": "single",
                  "enableTime": false,
                  "noCalendar": false,
                  "format": "yyyy-MM-dd",
                  "hourIncrement": 1,
                  "minuteIncrement": 1,
                  "time_24hr": true,
                  "minDate": null,
                  "disableWeekends": false,
                  "disableWeekdays": false,
                  "maxDate": null
              }
            },
            {
              "type": "radio",
              "label": "Details about the notice of Intention to adjudicate can be found in (relevant legislation), Was an notice to apply for adjudication served?",
              "input": true,
              "inline": true,
              "tableView": false,
              "key": "etailsAboutTheNoticeOfIntentionToAdjudicate",
              "persistent": true,
                values: [
                  {value: 'yes', label: 'Yes'},
                  {value: 'no', label: 'No'}
                ],
                "validate": {
                  "required": true
                }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "Your claim may be invalid under (relevant legislation) NSW: s17(2)",
              "inputMask": "",
              "key": "claimUnderLegislationText_etailsAboutTheNoticeOfIntentionToAdjudicate_NSW",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              "conditional": {
                "json": {
                  "and": [
                    {"===": [{"var": "data.etailsAboutTheNoticeOfIntentionToAdjudicate"},"no"]},
                    {"==": [state, "NSW"]},
                  ],
                }
              }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "Your claim may be invalid under (relevant legislation) VIC: s18(2)",
              "inputMask": "",
              "key": "claimUnderLegislationText_etailsAboutTheNoticeOfIntentionToAdjudicate_VIC",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              "conditional": {
                "json": {
                  "and": [
                    {"===": [{"var": "data.etailsAboutTheNoticeOfIntentionToAdjudicate"},"no"]},
                    {"==": [state, "VIC"]},
                  ],
                }
              }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "Your claim may be invalid under (relevant legislation) SA: s17(2)",
              "inputMask": "",
              "key": "claimUnderLegislationText_etailsAboutTheNoticeOfIntentionToAdjudicate_SA",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              "conditional": {
                "json": {
                  "and": [
                    {"===": [{"var": "data.etailsAboutTheNoticeOfIntentionToAdjudicate"},"no"]},
                    {"==": [state, "SA"]},
                  ],
                }
              }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "Your claim may be invalid under (relevant legislation) ACT: s19(2)",
              "inputMask": "",
              "key": "claimUnderLegislationText_etailsAboutTheNoticeOfIntentionToAdjudicate_ACT",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              "conditional": {
                "json": {
                  "and": [
                    {"===": [{"var": "data.etailsAboutTheNoticeOfIntentionToAdjudicate"},"no"]},
                    {"==": [state, "ACT"]},
                  ],
                }
              }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "Your claim may be invalid under (relevant legislation) TAS:s21(4)",
              "inputMask": "",
              "key": "claimUnderLegislationText_etailsAboutTheNoticeOfIntentionToAdjudicate_TAS",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              "conditional": {
                "json": {
                  "and": [
                    {"===": [{"var": "data.etailsAboutTheNoticeOfIntentionToAdjudicate"},"no"]},
                    {"==": [state, "TAS"]},
                  ],
                }
              }
            },
            {
              "label": "Date served",
              "format": "yyyy-MM-dd",
              "tableView": false,
              "enableMinDateInput": false,
              "datePicker": {
                  "disableWeekends": false,
                  "disableWeekdays": false
              },
              "enableMaxDateInput": false,
              "enableTime": false,
              "timePicker": {
                  "showMeridian": false
              },
              "key": "dateServed_72",
              "type": "datetime",
              "input": true,
              "widget": {
                  "type": "calendar",
                  "displayInTimezone": "viewer",
                  "locale": "en",
                  "useLocaleSettings": false,
                  "allowInput": true,
                  "mode": "single",
                  "enableTime": false,
                  "noCalendar": false,
                  "format": "yyyy-MM-dd",
                  "hourIncrement": 1,
                  "minuteIncrement": 1,
                  "time_24hr": true,
                  "minDate": null,
                  "disableWeekends": false,
                  "disableWeekdays": false,
                  "maxDate": null
              },
              "validate": {
                "required": true,
                "customPrivate": false
              },

            },
            {
              "type": "radio",
              "label": "Did the notice allow for (x) business days for respondent to provide payment schedule as per (x)?",
              "input": true,
              "inline": true,
              "tableView": false,
              "key": "didYouNoticeAllowBusinessDays",
              "persistent": true,
                values: [
                  {value: 'yes', label: 'Yes'},
                  {value: 'no', label: 'No'}
                ],
                "validate": {
                  "required": true
              }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "If no PS served and TODAY > 15 business days after q72, and 20 business days after q62, Your claim may be invalid under s17(2) of the Act",
              "inputMask": "",
              "key": "claimUnderLegislationText_etailsAboutTheNoticeOfIntentionToAdjudicate_NSW",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              "conditional": {
                "json": {
                  "and": [
                    {"===": [{"var": "data.didYouNoticeAllowBusinessDays"},"no"]},
                    {"==": [state, "NSW"]},
                  ],
                }
              }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "If no PS served and TODAY > 7 business days after q72, after 10 business days from q62, Your claim may be invalid under s18(2) of the Act",
              "inputMask": "",
              "key": "claimUnderLegislationText_etailsAboutTheNoticeOfIntentionToAdjudicate_VIC",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              "conditional": {
                "json": {
                  "and": [
                    {"===": [{"var": "data.didYouNoticeAllowBusinessDays"},"no"]},
                    {"==": [state, "VIC"]},
                  ],
                }
              }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "If no PS served and TODAY > 20 business days after q72, and 20 business days after q62, Your claim may be invalid under s17(2) of the Act",
              "inputMask": "",
              "key": "claimUnderLegislationText_etailsAboutTheNoticeOfIntentionToAdjudicate_SA",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              "conditional": {
                "json": {
                  "and": [
                    {"===": [{"var": "data.didYouNoticeAllowBusinessDays"},"no"]},
                    {"==": [state, "SA"]},
                  ],
                }
              }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "If no PS served and TODAY > 15 business days after q72, after 10 business days from q62, Your claim may be invalid under s19(2) of the Act",
              "inputMask": "",
              "key": "claimUnderLegislationText_etailsAboutTheNoticeOfIntentionToAdjudicate_ACT",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              "conditional": {
                "json": {
                  "and": [
                    {"===": [{"var": "data.didYouNoticeAllowBusinessDays"},"no"]},
                    {"==": [state, "ACT"]},
                  ],
                }
              }
            },
            {
              "type": "htmlelement",
              "input": false,
              "tableView": true,
              "content": "If no PS served and TODAY > 15 business days after q72, and 20 business days after q62, Your claim may be invalid under s17(2) of the Act",
              "inputMask": "",
              "key": "claimUnderLegislationText_etailsAboutTheNoticeOfIntentionToAdjudicate_TAS",
              "prefix": "",
              "suffix": "",
              "multiple": false,
              "protected": false,
              "unique": false,
              "persistent": true,
              "conditional": {
                "json": {
                  "and": [
                    {"===": [{"var": "data.didYouNoticeAllowBusinessDays"},"no"]},
                    {"==": [state, "TAS"]},
                  ],
                }
              }
            },
            {
              "type": "radio",
              "label": "Declaration: I hereby declare that, The Information provided in this application is, to the best of my knowledge, accurate and truthful",
              "input": true,
              "inline": true,
              "tableView": false,
              "key": "userDeclarationText",
              "persistent": true,
                values: [
                  {value: 'yes', label: 'Yes'},
                  {value: 'no', label: 'No'}
                ],
                "validate": {
                  "required": true
              }
            },
            {
              "type": "radio",
              "label": "Service declaration (see attached page)",
              "input": true,
              "inline": true,
              "tableView": false,
              "key": "serviceDeclaration",
              "persistent": true,
                values: [
                  {value: 'yes', label: 'Yes'},
                  {value: 'no', label: 'No'}
                ],
                "validate": {
                  "required": true
              }
            },
            // check for other states
          // {
          //   "type": "button",
          //   "label": "Next",
          //   "key": "submit",
          //   "disableOnInvalid": true,
          //   "input": true,
          //   "tableView": false
          // }
        ]
    }

  this.formData = {
    data: {
      "firstName": "Laksh",
      "lastName": "Mikkili"
    }
  };
}

onSubmit(abc: any) {
    console.log(abc.data);
    // this.router.navigateByUrl('/file-upload');
  }
}
